function retry(callback) {
  try {
    callback();
  } catch (e) {
    setTimeout(function() {
      retry(callback);
    }, 100);
  }
}

function setupIframeHeight() {
  var bodyHeight = document.getElementsByTagName("body")[0].clientHeight;
  if (bodyHeight === 0) {
    throw new Error();
  }
  window.top.SET_IFRAME_HEIGHT(bodyHeight + 16 + "px");
}

document
  .getElementsByTagName("select")[0]
  .addEventListener("change", function() {
    setTimeout(function() {
      setupIframeHeight();
    }, 0);
  });

document.addEventListener("click", function() {
  setTimeout(function() {
    setupIframeHeight();
  }, 0);
});

document.addEventListener("DOMContentLoaded", function() {
  document
    .querySelector("input[type=submit]")
    .addEventListener("click", function() {
      window.top.SCROLL_TOP();
      window.top.SET_LOADER();
    });
  retry(function() {
    setupIframeHeight();
    window.top.REMOVE_LOADER();
  });

  var doIt;
  function resizeDw() {
    setupIframeHeight();
  }
  window.onresize = function() {
    clearTimeout(doIt);
    doIt = setTimeout(function() {
      resizeDw();
    }, 100);
  };
});
